// // src/components/layout/Dashboard/Restaurant/Offers.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// import { usePermissions } from '../../../../hooks/usePermissions';
// import { postData } from '../../../../services/Fetchnodeservices';

// // Icons as SVG components
// const CalendarIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>);
// const TagIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>);
// const PercentIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M19 5L5 19M9 6.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zM20 17.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/></svg>);
// const GiftIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>);
// const SwapIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M17 2l4 4-4 4"/><path d="M3 12h15.5M7 22l-4-4 4-4"/><path d="M21 12H5.5"/><path d="M17 12v8"/></svg>);
// const PlusIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
// const CheckIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>);
// const ChevronDownIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="6 9 12 15 18 9"/></svg>);
// const ClockIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>);
// const EditIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
// const TrashIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);
// const EyeIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>);
// const BackIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
// const SparklesIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 3L14 8L19 10L14 12L12 17L10 12L5 10L10 8L12 3Z"/><path d="M19 4L20 7L23 8L20 9L19 12L18 9L15 8L18 7L19 4Z"/></svg>);
// const TrendingIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M23 6l-9.5 9.5-5-5L1 18"/><path d="M17 6h6v6"/></svg>);

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN COMPONENT
// // ─────────────────────────────────────────────────────────────────────────────
// const AddOffer = ({ isDark = false }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { hasPermission } = usePermissions();
  
//   const [designation_id, setDesignationId] = useState(null);
//   const [restaurantName, setRestaurantName] = useState('');
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedOfferProductIds, setSelectedOfferProductIds] = useState([]);
//   const [productSearch, setProductSearch] = useState('');
//   const [offerName, setOfferName] = useState('');
//   const [offerScope, setOfferScope] = useState('product');
//   const [minCartValue, setMinCartValue] = useState('');
//   const [editingOfferId, setEditingOfferId] = useState(null);
//   const [showProductDropdown, setShowProductDropdown] = useState(false);
//   const [selectedOfferType, setSelectedOfferType] = useState('fixed');
//   const [discountAmount, setDiscountAmount] = useState('');
//   const [discountPercent, setDiscountPercent] = useState('');
//   const [buyQuantity, setBuyQuantity] = useState('');
//   const [getQuantity, setGetQuantity] = useState('');
//   const [selectedFreeProduct, setSelectedFreeProduct] = useState(null);
//   const [showFreeProductDropdown, setShowFreeProductDropdown] = useState(false);
//   const [validFrom, setValidFrom] = useState('');
//   const [validTo, setValidTo] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [offers, setOffers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [productList, setProductList] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(false);
//   const [activeTab, setActiveTab] = useState('create');
//   const [selectedOfferIds, setSelectedOfferIds] = useState([]);
//   const [bulkCategory, setBulkCategory] = useState('');
//   const [bulkDeleting, setBulkDeleting] = useState(false);
  
//   const offersSectionRef = useRef(null);
//   const initialEditAppliedRef = useRef(null);

//   useEffect(() => {
//     if (!hasPermission('restaurants.active_offers')) {
//       alert("You don't have permission to manage offers");
//       navigate(-1);
//     }
//   }, []);

//   // 🔴 RED THEME OFFER TYPES
//   const offerTypes = [
//     { id: 'fixed', title: 'Flat Discount', description: 'Flat rupee amount off', icon: <TagIcon />, color: '#ef4444', bgColor: '#fef2f2', darkBgColor: '#450a0a', apiType: 'flat' },
//     { id: 'percentage', title: 'Percentage Off', description: '% off on product or cart', icon: <PercentIcon />, color: '#dc2626', bgColor: '#fef2f2', darkBgColor: '#450a0a', apiType: 'percent' },
//     { id: 'buyNGetN', title: 'Buy N Get N', description: 'Same product free', icon: <GiftIcon />, color: '#f59e0b', bgColor: '#fffbeb', darkBgColor: '#451a03', apiType: 'bogo' },
//     { id: 'buyNGetX', title: 'Buy N Get X', description: 'A different product free', icon: <SwapIcon />, color: '#e11d48', bgColor: '#fff1f2', darkBgColor: '#4c0519', apiType: 'bogo' }
//   ];

//   // 🔴 RED & WHITE THEME-AWARE STYLES
//   const getThemeStyles = () => ({
//     bgPrimary: isDark ? '#0a0505' : '#ffffff',
//     bgSecondary: isDark ? '#140a0a' : '#ffffff',
//     bgTertiary: isDark ? '#0f0505' : '#fef2f2',
//     textPrimary: isDark ? '#f1f5f9' : '#0f172a',
//     textSecondary: isDark ? '#94a3b8' : '#64748b',
//     textMuted: isDark ? '#64748b' : '#94a3b8',
//     border: isDark ? '#2a1010' : '#fecaca',
//     borderLight: isDark ? '#450a0a' : '#fee2e2',
//     cardBg: isDark ? '#140a0a' : '#ffffff',
//     inputBg: isDark ? '#0f0505' : '#fef2f2',
//     hoverBg: isDark ? '#2a1010' : '#fee2e2',
//     primary: '#ef4444',
//     primaryGradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
//   });

//   const styles = getThemeStyles();
//   const productIdOf = (product) => String(product?.product_id ?? product?.id ?? product?.uid ?? '');
//   const productCategoryOf = (product) => String(product?.category || product?.main_category || product?.category_name || product?.type || 'Uncategorized').trim() || 'Uncategorized';

//   const fetchProducts = async () => {
//     if (!designation_id) return;
//     setLoadingProducts(true);
//     try {
//       const response = await postData("offers/menu", { designation_id: designation_id });
//       let productsData = [];
//       if (response && response.status === true && response.data) {
//         response.data.forEach((menuItem) => {
//           if (menuItem.items) {
//             let itemsJson = menuItem.items;
//             if (typeof itemsJson === 'string') {
//               try {
//                 const parsedItems = JSON.parse(itemsJson);
//                 if (Array.isArray(parsedItems)) productsData = [...productsData, ...parsedItems];
//               } catch (parseError) { console.error("Error parsing items JSON:", parseError); }
//             } else if (Array.isArray(itemsJson)) {
//               productsData = [...productsData, ...itemsJson];
//             }
//           }
//         });
//       }
//       setProductList(productsData);
//     } catch (error) {
//       console.error("Error fetching products:", error);
//     } finally {
//       setLoadingProducts(false);
//     }
//   };

//   const fetchOffers = async () => {
//     if (!designation_id) return;
//     setLoading(true);
//     try {
//       const response = await postData("offers/offer", { designation_id: designation_id });
//       let offersData = [];
//       if (response && response.status === true && response.data) {
//         offersData = response.data;
//       }
//       setOffers(offersData);
//     } catch (error) {
//       console.error("Error fetching offers:", error);
//       setError(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (location.state && location.state.designation_id) {
//       setDesignationId(location.state.designation_id);
//       setRestaurantName(location.state.restaurantName || '');
//     } else {
//       const storedRestaurant = sessionStorage.getItem('selectedRestaurant');
//       if (storedRestaurant) {
//         const restaurant = JSON.parse(storedRestaurant);
//         setDesignationId(restaurant.designation_id);
//         setRestaurantName(restaurant.restaurantName || '');
//       }
//     }
//   }, [location]);

//   useEffect(() => {
//     if (designation_id) {
//       fetchProducts();
//       fetchOffers();
//     }
//   }, [designation_id]);

//   const isValid = () => {
//     if (!offerName.trim()) { alert('Please enter an offer title'); return false; }
//     if (offerScope === 'product' && selectedOfferProductIds.length === 0) { alert('Offer lagane ke liye kam se kam ek dish select karein'); return false; }
//     if (offerScope === 'cart' && (selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX')) { alert('BOGO offers can only be applied to products'); return false; }
//     if (offerScope === 'cart' && (!minCartValue || parseFloat(minCartValue) <= 0)) { alert('Please enter a valid minimum cart value'); return false; }
//     if (selectedOfferType === 'fixed' && (!discountAmount || parseFloat(discountAmount) <= 0)) { alert('Please enter a valid discount amount'); return false; }
//     if (selectedOfferType === 'percentage' && (!discountPercent || parseFloat(discountPercent) <= 0 || parseFloat(discountPercent) > 100)) { alert('Please enter a valid percentage (1-100)'); return false; }
//     if ((selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') && (!buyQuantity || parseInt(buyQuantity) <= 0)) { alert('Please enter valid buy quantity'); return false; }
//     if (selectedOfferType === 'buyNGetN' && (!getQuantity || parseInt(getQuantity) <= 0)) { alert('Please enter valid get quantity'); return false; }
//     if (selectedOfferType === 'buyNGetX' && !selectedFreeProduct) { alert('Please select the free product'); return false; }
//     if (validFrom && validTo && new Date(validFrom) > new Date(validTo)) { alert('End date must be after start date'); return false; }
//     return true;
//   };

//   const handleCreateOffer = async () => {
//     if (!isValid() || !designation_id) return;
//     setIsSubmitting(true);
//     const offerTypeMap = { fixed: 'flat', percentage: 'percent', buyNGetN: 'bogo', buyNGetX: 'bogo' };
    
//     const targetProducts = productList.filter((product) => selectedOfferProductIds.includes(productIdOf(product)));
//     const isBulkProductOffer = offerScope === 'product' && !editingOfferId && targetProducts.length > 1;
//     let offerData = {
//       id: editingOfferId || undefined,
//       designation_id,
//       product_id: offerScope === 'product' ? targetProducts[0]?.product_id : null,
//       product_name: offerScope === 'product' ? targetProducts[0]?.name : null,
//       offer_name: offerName.trim(),
//       offer_type: offerTypeMap[selectedOfferType],
//       offer_scope: offerScope,
//       min_cart_value: offerScope === 'cart' ? minCartValue : 0,
//       status: editingOfferId ? undefined : '1',
//     };

//     if (selectedOfferType === 'fixed') offerData.offer = discountAmount;
//     else if (selectedOfferType === 'percentage') offerData.offer = discountPercent;
//     else if (selectedOfferType === 'buyNGetN') { offerData.buy_quantity = buyQuantity; offerData.free_quantity = getQuantity; offerData.offer = `${buyQuantity}+${getQuantity}`; }
//     else if (selectedOfferType === 'buyNGetX') { offerData.buy_quantity = buyQuantity; offerData.free_quantity = '1'; offerData.item_free = selectedFreeProduct.product_id; offerData.offer = `${buyQuantity}+1`; }
    
//     if (validFrom) offerData.offer_start = validFrom;
//     if (validTo) offerData.offer_end = validTo;

//     try {
//       const endpoint = editingOfferId
//         ? "offers/update_offer"
//         : isBulkProductOffer
//           ? "offers/create_bulk_offer"
//           : "offers/create_offer";
//       if (isBulkProductOffer) {
//         offerData.products = targetProducts.map((product) => ({
//           product_id: product.product_id,
//           name: product.name,
//         }));
//       }
//       const response = await postData(endpoint, offerData);
//       if (response && response.status === true) {
//         alert(editingOfferId ? 'Offer updated successfully!' : (isBulkProductOffer ? `Offer applied to ${response?.data?.count || targetProducts.length} dishes!` : 'Offer created successfully!'));
//         resetForm();
//         await fetchOffers();
//         setActiveTab('manage');
//       } else {
//         alert(response?.message || `Failed to ${editingOfferId ? 'update' : 'create'} offer`);
//       }
//     } catch (error) {
//       alert('Failed to create offer: ' + error.message);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleDeleteOffer = async (offerId) => {
//     if (!window.confirm('Are you sure you want to delete this offer?')) return;
//     try {
//       const response = await postData("offers/delete_offer", { id: offerId });
//       if (response && response.status === true) {
//         alert('Offer deleted successfully!');
//         fetchOffers();
//       }
//     } catch (error) {
//       alert('Failed to delete offer');
//     }
//   };

//   const handleEditOffer = (offer) => {
//     const product = productList.find(p => String(p.product_id) === String(offer.product_id));
//     if (product) setSelectedProduct(product);
//     setSelectedOfferProductIds([]);
//     setProductSearch('');
//     setEditingOfferId(offer.id);
//     setOfferName(offer.offer_name || '');
//     setOfferScope(offer.offer_scope || 'product');
//     setMinCartValue(offer.min_cart_value ? String(offer.min_cart_value) : '');
    
//     if (offer.offer_type === 'flat' || offer.offer_type === 'discount') { setSelectedOfferType('fixed'); setDiscountAmount(offer.offer); }
//     else if (offer.offer_type === 'percent' || offer.offer_type === 'percentage') { setSelectedOfferType('percentage'); setDiscountPercent(offer.offer); }
//     else if (offer.offer_type === 'bogo' || offer.offer_type === 'buy_get' || offer.offer_type === 'buy_get_x') {
//       setSelectedOfferType(offer.item_free ? 'buyNGetX' : 'buyNGetN');
//       setBuyQuantity(offer.buy_quantity || '1');
//       setGetQuantity(offer.free_quantity || '1');
//       const freeProduct = productList.find(p => String(p.product_id) === String(offer.item_free));
//       setSelectedFreeProduct(freeProduct || null);
//     }
    
//     if (offer.offer_start) setValidFrom(offer.offer_start.split(' ')[0]);
//     if (offer.offer_end) setValidTo(offer.offer_end.split(' ')[0]);
//     setActiveTab('create');
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const productForOffer = (offer) => productList.find((product) => productIdOf(product) === String(offer?.product_id || ''));
//   const offerCategories = [...new Set(offers.map(productForOffer).filter(Boolean).map(productCategoryOf))].sort();
//   const toggleOfferSelection = (offerId) => setSelectedOfferIds((previous) => previous.includes(String(offerId)) ? previous.filter((id) => id !== String(offerId)) : [...previous, String(offerId)]);
//   const selectOffersByCategory = (category) => {
//     setBulkCategory(category);
//     if (!category) return;
//     setSelectedOfferIds(offers.filter((offer) => productCategoryOf(productForOffer(offer)) === category).map((offer) => String(offer.id)));
//   };
//   const handleBulkDeleteOffers = async () => {
//     if (!selectedOfferIds.length) return alert('Pehle jis dish ke offers hatane hain unhe select karein.');
//     if (!window.confirm(`${selectedOfferIds.length} selected offer(s) remove karne hain? Baaki dishes ke offers safe rahenge.`)) return;
//     setBulkDeleting(true);
//     try {
//       const response = await postData('offers/delete_bulk', { designation_id, offer_ids: selectedOfferIds });
//       if (response?.status) {
//         alert(response.message || 'Selected offers removed successfully');
//         setSelectedOfferIds([]); setBulkCategory(''); await fetchOffers();
//       } else alert(response?.message || 'Selected offers remove nahi ho paaye');
//     } catch (error) { alert('Selected offers remove nahi ho paaye'); }
//     finally { setBulkDeleting(false); }
//   };

//   useEffect(() => {
//     const editOffer = location.state?.editOffer;
//     if (!editOffer?.id || productList.length === 0 || initialEditAppliedRef.current === editOffer.id) return;
//     initialEditAppliedRef.current = editOffer.id;
//     handleEditOffer(editOffer);
//   }, [location.state, productList]);

//   const resetForm = () => {
//     setEditingOfferId(null);
//     setOfferName('');
//     setOfferScope('product');
//     setMinCartValue('');
//     setSelectedProduct(null);
//     setApplyToAllProducts(false);
//     setSelectedOfferType('fixed');
//     setDiscountAmount('');
//     setDiscountPercent('');
//     setBuyQuantity('');
//     setGetQuantity('');
//     setSelectedFreeProduct(null);
//     setValidFrom('');
//     setValidTo('');
//   };

//   const getOfferTypeText = (type) => {
//     const types = { 'flat': 'Flat', 'percent': 'Percentage', 'bogo': 'BOGO', 'combo': 'Combo', 'discount': 'Flat', 'percentage': 'Percentage', 'buy_get': 'Buy N Get N', 'buy_get_x': 'Buy N Get X' };
//     return types[type] || type;
//   };

//   const getOfferDescription = (offer) => {
//     if (offer.offer_type === 'flat') return `₹${offer.offer} off`;
//     if (offer.offer_type === 'percent') return `${offer.offer}% off`;
//     if (offer.offer_type === 'bogo') return `Buy ${offer.buy_quantity || 1}, Get ${offer.free_quantity || 1} free`;
//     if (offer.offer_type === 'combo') return `Combo for ₹${offer.offer}`;
//     if (offer.offer_type === 'discount') return `₹${offer.offer} off`;
//     if (offer.offer_type === 'percentage') return `${offer.offer}% off`;
//     if (offer.offer_type === 'buy_get') return `Buy ${offer.buy_quantity}, Get ${offer.free_quantity} free`;
//     if (offer.offer_type === 'buy_get_x') return `Buy ${offer.buy_quantity}, Get free product`;
//     return offer.offer_name;
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return 'N/A';
//     const date = new Date(dateStr);
//     return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
//   };

//   const handleBack = () => navigate(-1);
//   const getActiveOfferCount = () => offers.filter(offer => Number(offer.status) === 1).length;

//   const handleToggleOffer = async (offerId) => {
//     try {
//       const response = await postData('offers/toggle_status', { id: offerId });
//       if (response?.status === true) await fetchOffers();
//       else alert(response?.message || 'Failed to update offer status');
//     } catch (toggleError) {
//       alert('Failed to update offer status');
//     }
//   };

//   if (!hasPermission('restaurants.active_offers')) {
//     return (
//       <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: styles.bgPrimary, transition: 'background 0.3s ease' }}>
//         <div style={{ textAlign: 'center', background: styles.cardBg, padding: '60px', borderRadius: '24px', maxWidth: '400px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
//           <div style={{ fontSize: '64px', marginBottom: '16px' }}>🔒</div>
//           <h2 style={{ color: styles.textPrimary, marginBottom: '8px' }}>Access Denied</h2>
//           <p style={{ color: styles.textSecondary }}>You don't have permission to manage offers</p>
//           <button 
//             onClick={handleBack}
//             style={{
//               marginTop: '20px', padding: '10px 24px', background: styles.primaryGradient, border: 'none',
//               borderRadius: '12px', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: 600,
//               transition: 'transform 0.2s ease, opacity 0.2s ease'
//             }}
//             onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
//             onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//           >
//             Go Back
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!designation_id) {
//     return (
//       <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: styles.bgPrimary, transition: 'background 0.3s ease' }}>
//         <div style={{ textAlign: 'center', background: styles.cardBg, padding: '40px', borderRadius: '24px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
//           <div style={{ width: '48px', height: '48px', border: `3px solid ${styles.border}`, borderTopColor: styles.primary, borderRadius: '50%', margin: '0 auto 16px auto', animation: 'spin 1s linear infinite' }} />
//           <p style={{ color: styles.textSecondary, fontSize: '14px' }}>Loading restaurant information...</p>
//           <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={{ minHeight: '100vh', backgroundColor: styles.bgPrimary, fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", transition: 'all 0.3s ease' }}>
//       <style>{`
//         @keyframes spin { to { transform: rotate(360deg); } }
//         @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
//         .offer-card { animation: fadeIn 0.3s ease; }
//       `}</style>
      
//       <div style={{ position: 'relative', zIndex: 1, padding: '32px 24px' }}>
//         {/* Header */}
//         <div style={{ maxWidth: '1200px', margin: '0 auto 32px auto' }}>
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
//             <button 
//               onClick={handleBack} 
//               style={{ 
//                 display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px',
//                 background: styles.bgTertiary, border: `1px solid ${styles.border}`, borderRadius: '40px',
//                 color: styles.textPrimary, cursor: 'pointer', fontSize: '14px', fontWeight: '500',
//                 transition: 'all 0.3s ease'
//               }}
//               onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
//               onMouseLeave={(e) => e.currentTarget.style.background = styles.bgTertiary}
//             >
//               <BackIcon /> Back to Dashboard
//             </button>
            
//             <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: styles.bgTertiary, padding: '8px 20px', borderRadius: '40px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
//                 <SparklesIcon />
//                 <span style={{ color: styles.textPrimary, fontSize: '14px', fontWeight: '500' }}>{restaurantName}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//           {/* Stats Cards */}
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px' }}>
//             {[
//               { label: 'Total Products', value: productList.length, icon: <TagIcon /> },
//               { label: 'Active Offers', value: getActiveOfferCount(), icon: <TrendingIcon /> },
//               { label: 'Total Offers', value: offers.length, icon: <GiftIcon /> }
//             ].map((stat, idx) => (
//               <div key={idx} style={{ background: styles.cardBg, borderRadius: '20px', padding: '20px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                   <div>
//                     <p style={{ fontSize: '12px', color: styles.textSecondary, marginBottom: '8px' }}>{stat.label}</p>
//                     <p style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary }}>{stat.value}</p>
//                   </div>
//                   <div style={{ width: '40px', height: '40px', background: styles.bgTertiary, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: styles.primary, transition: 'all 0.3s ease' }}>
//                     {stat.icon}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Tabs */}
//           <div style={{ display: 'flex', gap: '12px', marginBottom: '24px', background: styles.bgTertiary, borderRadius: '60px', padding: '6px', width: 'fit-content', transition: 'all 0.3s ease' }}>
//             <button
//               onClick={() => setActiveTab('create')}
//               style={{
//                 padding: '12px 28px', borderRadius: '40px', border: 'none', fontSize: '14px', fontWeight: '600',
//                 cursor: 'pointer', transition: 'all 0.3s ease',
//                 background: activeTab === 'create' ? styles.bgSecondary : 'transparent',
//                 color: activeTab === 'create' ? styles.primary : styles.textSecondary
//               }}
//             >
//               ✨ Create Offer
//             </button>
//             <button
//               onClick={() => setActiveTab('manage')}
//               style={{
//                 padding: '12px 28px', borderRadius: '40px', border: 'none', fontSize: '14px', fontWeight: '600',
//                 cursor: 'pointer', transition: 'all 0.3s ease',
//                 background: activeTab === 'manage' ? styles.bgSecondary : 'transparent',
//                 color: activeTab === 'manage' ? styles.primary : styles.textSecondary
//               }}
//             >
//               📋 Manage Offers
//             </button>
//           </div>

//           {/* Create Offer Form */}
//           {activeTab === 'create' && (
//             <div className="offer-card" style={{ background: styles.cardBg, borderRadius: '32px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
//               <div style={{ padding: '32px', borderBottom: `1px solid ${styles.border}`, background: isDark ? '#140a0a' : 'linear-gradient(135deg, #fef2f2 0%, #ffffff 100%)', transition: 'all 0.3s ease' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                   <div style={{ width: '48px', height: '48px', background: styles.primaryGradient, borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)' }}>
//                     <SparklesIcon style={{ color: 'white' }} />
//                   </div>
//                   <div>
//                     <h2 style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>Create New Offer</h2>
//                     <p style={{ fontSize: '14px', color: styles.textSecondary, marginTop: '4px' }}>Design attractive promotions to boost your sales</p>
//                   </div>
//                 </div>
//               </div>

//               <div style={{ padding: '32px' }}>
//                 {/* Offer title */}
//                 <div style={{ marginBottom: '24px' }}>
//                   <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Campaign Title</label>
//                   <input
//                     type="text"
//                     placeholder="e.g., Weekend Special"
//                     value={offerName}
//                     onChange={(e) => setOfferName(e.target.value)}
//                     style={{ width: '100%', boxSizing: 'border-box', padding: '14px 18px', border: `2px solid ${styles.border}`, borderRadius: '16px', background: styles.inputBg, color: styles.textPrimary, fontSize: '14px', outline: 'none' }}
//                   />
//                 </div>

//                 {/* Offer scope */}
//                 <div style={{ marginBottom: '24px' }}>
//                   <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '10px' }}>Offer Applies To</label>
//                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '12px' }}>
//                     {[
//                       { id: 'product', label: 'Product Offer', hint: 'Apply on one menu item' },
//                       { id: 'cart', label: 'Cart Offer', hint: 'Apply above a minimum order' }
//                     ].map((scope) => (
//                       <button
//                         key={scope.id}
//                         type="button"
//                         onClick={() => {
//                           setOfferScope(scope.id);
//                           if (scope.id === 'cart') {
//                             setApplyToAllProducts(false);
//                             setApplyToCategory('');
//                             if (selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') setSelectedOfferType('percentage');
//                           }
//                         }}
//                         style={{ padding: '15px 18px', borderRadius: '16px', border: `2px solid ${offerScope === scope.id ? styles.primary : styles.border}`, background: offerScope === scope.id ? styles.bgTertiary : styles.cardBg, color: styles.textPrimary, cursor: 'pointer', textAlign: 'left' }}
//                       >
//                         <strong style={{ display: 'block', fontSize: '14px' }}>{scope.label}</strong>
//                         <span style={{ fontSize: '11px', color: styles.textSecondary }}>{scope.hint}</span>
//                       </button>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Product Selection */}
//                 {offerScope === 'product' && (
//                 <div style={{ marginBottom: '32px' }}>
//                   <label style={{ display: 'block', fontSize: '14px', fontWeight: '700', color: styles.textPrimary, marginBottom: '6px' }}>Choose dishes for this offer</label>
//                   <p style={{ color: styles.textSecondary, fontSize: '12px', margin: '0 0 12px' }}>Search “pizza” and select Pizza dishes. Or select all, search “roll”, then untick Rolls.</p>
//                   <input value={productSearch} onChange={(event) => setProductSearch(event.target.value)} placeholder="Search dish: pizza, roll, burger..." style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: '10px', border: `1px solid ${styles.border}`, background: styles.inputBg, color: styles.textPrimary, marginBottom: '10px' }} />
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '9px', flexWrap: 'wrap', marginBottom: '10px' }}>
//                     <button type="button" onClick={() => setSelectedOfferProductIds(productList.map(productIdOf))} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textPrimary, cursor: 'pointer', fontWeight: 700, fontSize: '12px' }}>Select all dishes</button>
//                     <button type="button" onClick={() => setSelectedOfferProductIds([])} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textSecondary, cursor: 'pointer', fontWeight: 700, fontSize: '12px' }}>Clear selection</button>
//                     <span style={{ color: styles.primary, fontWeight: 800, fontSize: '12px' }}>{selectedOfferProductIds.length} dish(es) selected</span>
//                   </div>
//                   <div style={{ maxHeight: '280px', overflowY: 'auto', border: `1px solid ${styles.border}`, borderRadius: '12px', background: styles.cardBg }}>
//                     {loadingProducts ? <div style={{ padding: '18px', color: styles.textMuted }}>Loading dishes...</div> : productList.filter((product) => `${product.name || ''} ${productCategoryOf(product)}`.toLowerCase().includes(productSearch.toLowerCase())).map((product) => {
//                       const id = productIdOf(product); const checked = selectedOfferProductIds.includes(id);
//                       return <label key={id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 13px', borderBottom: `1px solid ${styles.borderLight}`, cursor: 'pointer', background: checked ? styles.bgTertiary : 'transparent' }}>
//                         <input type="checkbox" checked={checked} onChange={() => setSelectedOfferProductIds((previous) => checked ? previous.filter((item) => item !== id) : [...previous, id])} style={{ accentColor: styles.primary, width: '16px', height: '16px' }} />
//                         <span style={{ flex: 1, color: styles.textPrimary, fontSize: '13px', fontWeight: 600 }}>{product.name}</span><span style={{ color: styles.textMuted, fontSize: '11px' }}>{productCategoryOf(product)}</span>
//                       </label>;
//                     })}
//                   </div>
//                 </div>
//                 )}

//                 {offerScope === 'cart' && (
//                   <div style={{ marginBottom: '32px' }}>
//                     <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Minimum Cart Value (₹)</label>
//                     <input
//                       type="number"
//                       min="1"
//                       placeholder="e.g., 499"
//                       value={minCartValue}
//                       onChange={(e) => setMinCartValue(e.target.value)}
//                       style={{ width: '100%', boxSizing: 'border-box', padding: '14px 18px', border: `2px solid ${styles.border}`, borderRadius: '16px', background: styles.inputBg, color: styles.textPrimary, fontSize: '14px', outline: 'none' }}
//                     />
//                   </div>
//                 )}

//                 {/* Offer Type Selection */}
//                 <div style={{ marginBottom: '32px' }}>
//                   <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '12px' }}>Offer Type</label>
//                   <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
//                     {offerTypes.map((type) => (
//                       <button
//                         key={type.id}
//                         disabled={offerScope === 'cart' && (type.id === 'buyNGetN' || type.id === 'buyNGetX')}
//                         onClick={() => setSelectedOfferType(type.id)}
//                         style={{
//                           padding: '20px', borderRadius: '20px',
//                           border: `2px solid ${selectedOfferType === type.id ? type.color : styles.border}`,
//                           background: selectedOfferType === type.id ? (isDark ? type.darkBgColor : type.bgColor) : styles.cardBg,
//                           cursor: 'pointer', textAlign: 'center', transition: 'all 0.3s ease',
//                           transform: selectedOfferType === type.id ? 'scale(1.02)' : 'scale(1)',
//                           opacity: offerScope === 'cart' && (type.id === 'buyNGetN' || type.id === 'buyNGetX') ? 0.45 : 1
//                         }}
//                       >
//                         <div style={{
//                           width: '56px', height: '56px', borderRadius: '28px',
//                           background: selectedOfferType === type.id ? `${type.color}20` : styles.bgTertiary,
//                           display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px auto',
//                           color: selectedOfferType === type.id ? type.color : styles.textSecondary, transition: 'all 0.3s ease'
//                         }}>
//                           {type.icon}
//                         </div>
//                         <span style={{ fontSize: '15px', fontWeight: '600', color: selectedOfferType === type.id ? type.color : styles.textPrimary, marginBottom: '4px', display: 'block' }}>{type.title}</span>
//                         <span style={{ fontSize: '12px', color: styles.textSecondary }}>{type.description}</span>
//                       </button>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Dynamic Fields */}
//                 {(selectedOfferType === 'fixed' || selectedOfferType === 'percentage') && (
//                   <div style={{ marginBottom: '32px' }}>
//                     <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>
//                       {selectedOfferType === 'fixed' ? 'Discount Amount (₹)' : 'Discount Percentage (%)'}
//                     </label>
//                     <div style={{ 
//                       display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', 
//                       backgroundColor: styles.inputBg, transition: 'all 0.2s ease'
//                     }}>
//                       {selectedOfferType === 'fixed' ? 
//                         <span style={{ fontSize: '20px', fontWeight: '600', color: styles.primary, marginRight: '12px' }}>₹</span> : 
//                         <div style={{ marginRight: '12px', color: styles.primary }}><PercentIcon /></div>
//                       }
//                       <input 
//                         type="number" 
//                         style={{ 
//                           flex: 1, padding: '14px 0', fontSize: '16px', fontWeight: '500', border: 'none', outline: 'none', 
//                           backgroundColor: 'transparent', color: styles.textPrimary
//                         }} 
//                         placeholder={selectedOfferType === 'fixed' ? 'e.g., 500' : 'e.g., 20'} 
//                         value={selectedOfferType === 'fixed' ? discountAmount : discountPercent} 
//                         onChange={(e) => selectedOfferType === 'fixed' ? setDiscountAmount(e.target.value) : setDiscountPercent(e.target.value)} 
//                       />
//                       {selectedOfferType === 'percentage' && <span style={{ fontSize: '16px', fontWeight: '500', color: styles.textSecondary, marginLeft: '8px' }}>%</span>}
//                     </div>
//                   </div>
//                 )}

//                 {(selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') && (
//                   <>
//                     <div style={{ marginBottom: '24px' }}>
//                       <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Buy Quantity</label>
//                       <div style={{ display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
//                         <GiftIcon style={{ color: styles.primary }} />
//                         <input 
//                           type="number" 
//                           style={{ flex: 1, padding: '14px 0', fontSize: '16px', border: 'none', outline: 'none', backgroundColor: 'transparent', marginLeft: '12px', color: styles.textPrimary }} 
//                           placeholder="e.g., 2" 
//                           value={buyQuantity} 
//                           onChange={(e) => setBuyQuantity(e.target.value)} 
//                         />
//                       </div>
//                     </div>
//                     {selectedOfferType === 'buyNGetN' && (
//                       <div style={{ marginBottom: '24px' }}>
//                         <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Get Quantity (Free)</label>
//                         <div style={{ display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
//                           <GiftIcon style={{ color: '#10B981' }} />
//                           <input 
//                             type="number" 
//                             style={{ flex: 1, padding: '14px 0', fontSize: '16px', border: 'none', outline: 'none', backgroundColor: 'transparent', marginLeft: '12px', color: styles.textPrimary }} 
//                             placeholder="e.g., 1" 
//                             value={getQuantity} 
//                             onChange={(e) => setGetQuantity(e.target.value)} 
//                           />
//                         </div>
//                       </div>
//                     )}
//                     {selectedOfferType === 'buyNGetX' && (
//                       <div style={{ marginBottom: '24px' }}>
//                         <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Free Product</label>
//                         <div style={{ position: 'relative' }}>
//                           <button 
//                             onClick={() => setShowFreeProductDropdown(!showFreeProductDropdown)} 
//                             style={{ 
//                               width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', 
//                               border: `2px solid ${styles.border}`, borderRadius: '16px', backgroundColor: styles.inputBg, cursor: 'pointer', 
//                               fontSize: '14px', color: styles.textPrimary, transition: 'all 0.2s ease'
//                             }}
//                             onMouseEnter={(e) => e.currentTarget.style.borderColor = styles.primary}
//                             onMouseLeave={(e) => e.currentTarget.style.borderColor = styles.border}
//                           >
//                             <span style={selectedFreeProduct ? { color: styles.textPrimary, fontWeight: '500' } : { color: styles.textMuted }}>
//                               {selectedFreeProduct ? selectedFreeProduct.name : 'Select free product'}
//                             </span>
//                             <ChevronDownIcon />
//                           </button>
//                           {showFreeProductDropdown && (
//                             <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: '8px', border: `1px solid ${styles.border}`, borderRadius: '16px', backgroundColor: styles.cardBg, zIndex: 10, maxHeight: '250px', overflow: 'auto', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)', transition: 'all 0.3s ease' }}>
//                               {productList.filter(p => p.product_id !== selectedProduct?.product_id).map((product) => (
//                                 <div 
//                                   key={product.product_id} 
//                                   onClick={() => { setSelectedFreeProduct(product); setShowFreeProductDropdown(false); }} 
//                                   style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', cursor: 'pointer', borderBottom: `1px solid ${styles.borderLight}`, transition: 'background 0.2s ease' }}
//                                   onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
//                                   onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                                 >
//                                   <span style={{ fontSize: '14px', color: styles.textPrimary }}>{product.name}</span>
//                                   {selectedFreeProduct?.product_id === product.product_id && <CheckIcon style={{ color: '#10B981' }} />}
//                                 </div>
//                               ))}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </>
//                 )}

//                 {/* Validity */}
//                 <div style={{ marginBottom: '32px' }}>
//                   <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Validity Period (Optional)</label>
//                   <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
//                     <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '10px 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
//                       <CalendarIcon style={{ color: styles.primary }} />
//                       <input 
//                         type="date" 
//                         style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '14px', color: styles.textPrimary }} 
//                         value={validFrom} 
//                         onChange={(e) => setValidFrom(e.target.value)} 
//                       />
//                       <span style={{ fontSize: '12px', color: styles.textMuted }}>Start</span>
//                     </div>
//                     <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '10px 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
//                       <ClockIcon style={{ color: styles.primary }} />
//                       <input 
//                         type="date" 
//                         style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '14px', color: styles.textPrimary }} 
//                         value={validTo} 
//                         onChange={(e) => setValidTo(e.target.value)} 
//                       />
//                       <span style={{ fontSize: '12px', color: styles.textMuted }}>End</span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Submit Button */}
//                 <button 
//                   onClick={handleCreateOffer} 
//                   disabled={isSubmitting} 
//                   style={{ 
//                     width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '16px',
//                     background: isSubmitting ? (isDark ? '#4B5563' : '#9CA3AF') : styles.primaryGradient,
//                     border: 'none', borderRadius: '20px', color: '#FFFFFF', fontSize: '16px', fontWeight: '600', 
//                     cursor: isSubmitting ? 'not-allowed' : 'pointer', boxShadow: isSubmitting ? 'none' : '0 4px 12px rgba(239, 68, 68, 0.3)',
//                     transition: 'transform 0.2s ease, box-shadow 0.2s ease, background 0.3s ease'
//                   }}
//                   onMouseEnter={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(-2px)')}
//                   onMouseLeave={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(0)')}
//                 >
//                   <PlusIcon />
//                   <span>{isSubmitting ? (editingOfferId ? 'Updating Offer...' : 'Creating Offer...') : (editingOfferId ? 'Update Offer' : 'Create Offer')}</span>
//                 </button>
//                 {editingOfferId && (
//                   <button
//                     type="button"
//                     onClick={resetForm}
//                     style={{ width: '100%', marginTop: '10px', padding: '12px', borderRadius: '16px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textSecondary, cursor: 'pointer', fontWeight: 600 }}
//                   >
//                     Cancel Editing
//                   </button>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* Manage Offers Table */}
//           {activeTab === 'manage' && (
//             <div ref={offersSectionRef} style={{ background: styles.cardBg, borderRadius: '32px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
//               <div style={{ padding: '24px 32px', borderBottom: `1px solid ${styles.border}`, background: isDark ? '#140a0a' : 'linear-gradient(135deg, #fef2f2 0%, #ffffff 100%)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', transition: 'all 0.3s ease' }}>
//                 <div>
//                   <h3 style={{ fontSize: '20px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>All Offers</h3>
//                   <p style={{ fontSize: '14px', color: styles.textSecondary, marginTop: '4px' }}>Manage and monitor your existing promotions</p>
//                 </div>
//                 <button 
//                   onClick={fetchOffers} 
//                   style={{ 
//                     display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 20px', 
//                     background: styles.primaryGradient, border: 'none', borderRadius: '12px', color: 'white', 
//                     fontSize: '13px', fontWeight: '500', cursor: 'pointer', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
//                     transition: 'transform 0.2s ease, opacity 0.2s ease'
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'}
//                   onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//                 >
//                   <EyeIcon /> Refresh ({offers.length})
//                 </button>
//               </div>

//               <div style={{ padding: '14px 32px', borderBottom: `1px solid ${styles.border}`, display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', background: styles.bgTertiary }}>
//                 <select value={bulkCategory} onChange={(event) => selectOffersByCategory(event.target.value)} style={{ minWidth: '190px', padding: '9px 11px', borderRadius: '9px', border: `1px solid ${styles.border}`, color: styles.textPrimary, background: styles.cardBg }}>
//                   <option value="">Select a category to select its offers</option>
//                   {offerCategories.map((category) => <option key={category} value={category}>{category}</option>)}
//                 </select>
//                 <span style={{ color: styles.textSecondary, fontSize: '12px', fontWeight: 600 }}>{selectedOfferIds.length} offer(s) selected</span>
//                 <button onClick={() => setSelectedOfferIds(offers.map((offer) => String(offer.id)))} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textPrimary, cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Select all</button>
//                 <button onClick={() => setSelectedOfferIds([])} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textSecondary, cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Clear</button>
//                 <button disabled={!selectedOfferIds.length || bulkDeleting} onClick={handleBulkDeleteOffers} style={{ marginLeft: 'auto', padding: '9px 13px', borderRadius: '8px', border: 'none', background: !selectedOfferIds.length || bulkDeleting ? '#94a3b8' : '#dc2626', color: '#fff', cursor: !selectedOfferIds.length || bulkDeleting ? 'not-allowed' : 'pointer', fontWeight: 700, fontSize: '12px' }}>{bulkDeleting ? 'Removing…' : 'Remove selected offers'}</button>
//               </div>

//               {loading ? (
//                 <div style={{ textAlign: 'center', padding: '60px', color: styles.textSecondary }}>
//                   <div style={{ width: '48px', height: '48px', border: `3px solid ${styles.border}`, borderTopColor: styles.primary, borderRadius: '50%', margin: '0 auto 16px auto', animation: 'spin 1s linear infinite' }} />
//                   <p>Loading offers...</p>
//                 </div>
//               ) : error ? (
//                 <div style={{ textAlign: 'center', padding: '60px', color: '#EF4444' }}>
//                   <p>Error loading offers: {error}</p>
//                   <button onClick={fetchOffers} style={{ marginTop: '16px', padding: '10px 24px', background: styles.primaryGradient, border: 'none', borderRadius: '12px', color: '#fff', cursor: 'pointer', transition: 'opacity 0.2s ease' }}
//                     onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
//                     onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
//                   >Try Again</button>
//                 </div>
//               ) : offers.length === 0 ? (
//                 <div style={{ textAlign: 'center', padding: '80px 40px', color: styles.textMuted }}>
//                   <div style={{ width: '80px', height: '80px', background: styles.bgTertiary, borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto', transition: 'all 0.3s ease' }}>
//                     <TagIcon style={{ width: '40px', height: '40px', opacity: 0.5, color: styles.primary }} />
//                   </div>
//                   <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px', color: styles.textPrimary }}>No offers yet</p>
//                   <p style={{ fontSize: '13px' }}>Create your first offer to start attracting more customers</p>
//                   <button 
//                     onClick={() => setActiveTab('create')} 
//                     style={{ marginTop: '20px', padding: '10px 24px', background: styles.primaryGradient, border: 'none', borderRadius: '12px', color: 'white', cursor: 'pointer', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)', transition: 'transform 0.2s ease' }}
//                     onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
//                     onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
//                   >
//                     Create Offer
//                   </button>
//                 </div>
//               ) : (
//                 <div style={{ overflowX: 'auto' }}>
//                   <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                       <tr style={{ background: styles.bgTertiary, borderBottom: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
//                         <th style={{ padding: '16px 12px', textAlign: 'center' }}><input type="checkbox" checked={offers.length > 0 && selectedOfferIds.length === offers.length} onChange={(event) => setSelectedOfferIds(event.target.checked ? offers.map((offer) => String(offer.id)) : [])} /></th>
//                         <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>#</th>
//                         <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Offer Name</th>
//                         <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Dish</th>
//                         <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Type</th>
//                         <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Details</th>
//                         <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Validity</th>
//                         <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Status</th>
//                         <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {offers.map((offer, index) => (
//                         <tr key={offer.id} style={{ borderBottom: `1px solid ${styles.borderLight}`, transition: 'background 0.2s ease' }}
//                           onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
//                           onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                         >
//                           <td style={{ padding: '16px 12px', textAlign: 'center' }}><input type="checkbox" checked={selectedOfferIds.includes(String(offer.id))} onChange={() => toggleOfferSelection(offer.id)} /></td>
//                           <td style={{ padding: '16px 20px', fontSize: '14px', fontWeight: '500', color: styles.textPrimary }}>{index + 1}</td>
//                           <td style={{ padding: '16px 20px', fontSize: '14px', fontWeight: '600', color: styles.textPrimary }}>{offer.offer_name}</td>
//                           <td style={{ padding: '16px 20px', fontSize: '13px', color: styles.textSecondary }}>{offer.product_name || productForOffer(offer)?.name || (offer.offer_scope === 'cart' ? 'Cart offer' : '—')}</td>
//                           <td style={{ padding: '16px 20px' }}>
//                             <span style={{ 
//                               display: 'inline-block', padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '600',
//                               background: offer.offer_type === 'discount' ? (isDark ? '#450a0a' : '#fef2f2') : 
//                                         offer.offer_type === 'percentage' ? (isDark ? '#450a0a' : '#fef2f2') :
//                                         offer.offer_type === 'buy_get' ? (isDark ? '#451a03' : '#fffbeb') : (isDark ? '#4c0519' : '#fff1f2'),
//                               color: offer.offer_type === 'discount' ? '#ef4444' : 
//                                      offer.offer_type === 'percentage' ? '#dc2626' :
//                                      offer.offer_type === 'buy_get' ? '#f59e0b' : '#e11d48',
//                               transition: 'all 0.3s ease'
//                             }}>
//                               {getOfferTypeText(offer.offer_type)}
//                             </span>
//                           </td>
//                           <td style={{ padding: '16px 20px', fontSize: '13px', color: styles.textSecondary }}>{getOfferDescription(offer)}</td>
//                           <td style={{ padding: '16px 20px', fontSize: '12px', color: styles.textSecondary }}>
//                             {formatDate(offer.offer_start)} → {formatDate(offer.offer_end)}
//                           </td>
//                           <td style={{ padding: '16px 20px', textAlign: 'center' }}>
//                             <button onClick={() => handleToggleOffer(offer.id)} title="Click to activate/deactivate" style={{ 
//                               display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '4px 12px', borderRadius: '20px', 
//                               fontSize: '11px', fontWeight: '600', 
//                               background: Number(offer.status) === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(148, 163, 184, 0.1)', 
//                               color: Number(offer.status) === 1 ? '#22c55e' : '#94a3b8',
//                               transition: 'all 0.3s ease', border: 'none', cursor: 'pointer'
//                             }}>
//                               <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: Number(offer.status) === 1 ? '#22c55e' : '#94a3b8' }}></span>
//                               {Number(offer.status) === 1 ? 'Active' : 'Inactive'}
//                             </button>
//                           </td>
//                           <td style={{ padding: '16px 20px', textAlign: 'center' }}>
//                             <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
//                               <button 
//                                 onClick={() => handleEditOffer(offer)} 
//                                 style={{ 
//                                   padding: '8px', background: 'transparent', border: 'none', cursor: 'pointer', color: '#f59e0b', borderRadius: '8px',
//                                   transition: 'background 0.2s ease'
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.background = isDark ? '#451a03' : '#fffbeb'}
//                                 onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                                 title="Edit Offer"
//                               >
//                                 <EditIcon />
//                               </button>
//                               <button 
//                                 onClick={() => handleDeleteOffer(offer.id)} 
//                                 style={{ 
//                                   padding: '8px', background: 'transparent', border: 'none', cursor: 'pointer', color: '#ef4444', borderRadius: '8px',
//                                   transition: 'background 0.2s ease'
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.background = isDark ? '#450a0a' : '#fef2f2'}
//                                 onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                                 title="Delete Offer"
//                               >
//                                 <TrashIcon />
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddOffer;


// src/components/layout/Dashboard/Restaurant/Offers.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { usePermissions } from '../../../../hooks/usePermissions';
import { postData } from '../../../../services/Fetchnodeservices';

// Icons as SVG components
const CalendarIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>);
const TagIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>);
const PercentIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M19 5L5 19M9 6.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zM20 17.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/></svg>);
const GiftIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>);
const SwapIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M17 2l4 4-4 4"/><path d="M3 12h15.5M7 22l-4-4 4-4"/><path d="M21 12H5.5"/><path d="M17 12v8"/></svg>);
const PlusIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const CheckIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>);
const ChevronDownIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="6 9 12 15 18 9"/></svg>);
const ClockIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>);
const EditIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
const TrashIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);
const EyeIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>);
const BackIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const SparklesIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 3L14 8L19 10L14 12L12 17L10 12L5 10L10 8L12 3Z"/><path d="M19 4L20 7L23 8L20 9L19 12L18 9L15 8L18 7L19 4Z"/></svg>);
const TrendingIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M23 6l-9.5 9.5-5-5L1 18"/><path d="M17 6h6v6"/></svg>);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const AddOffer = ({ isDark = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  
  const [designation_id, setDesignationId] = useState(null);
  const [restaurantName, setRestaurantName] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedOfferProductIds, setSelectedOfferProductIds] = useState([]);
  const [productSearch, setProductSearch] = useState('');
  const [offerName, setOfferName] = useState('');
  const [offerScope, setOfferScope] = useState('product');
  const [minCartValue, setMinCartValue] = useState('');
  const [editingOfferId, setEditingOfferId] = useState(null);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [selectedOfferType, setSelectedOfferType] = useState('fixed');
  const [discountAmount, setDiscountAmount] = useState('');
  const [discountPercent, setDiscountPercent] = useState('');
  const [buyQuantity, setBuyQuantity] = useState('');
  const [getQuantity, setGetQuantity] = useState('');
  const [selectedFreeProduct, setSelectedFreeProduct] = useState(null);
  const [showFreeProductDropdown, setShowFreeProductDropdown] = useState(false);
  const [validFrom, setValidFrom] = useState('');
  const [validTo, setValidTo] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productList, setProductList] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [activeTab, setActiveTab] = useState('create');
  const [selectedOfferIds, setSelectedOfferIds] = useState([]);
  const [bulkCategory, setBulkCategory] = useState('');
  const [bulkDeleting, setBulkDeleting] = useState(false);
  
  // REMOVED: setApplyToAllProducts and setApplyToCategory are not needed
  
  const offersSectionRef = useRef(null);
  const initialEditAppliedRef = useRef(null);

  useEffect(() => {
    if (!hasPermission('restaurants.active_offers')) {
      alert("You don't have permission to manage offers");
      navigate(-1);
    }
  }, []);

  // 🔴 RED THEME OFFER TYPES
  const offerTypes = [
    { id: 'fixed', title: 'Flat Discount', description: 'Flat rupee amount off', icon: <TagIcon />, color: '#ef4444', bgColor: '#fef2f2', darkBgColor: '#450a0a', apiType: 'flat' },
    { id: 'percentage', title: 'Percentage Off', description: '% off on product or cart', icon: <PercentIcon />, color: '#dc2626', bgColor: '#fef2f2', darkBgColor: '#450a0a', apiType: 'percent' },
    { id: 'buyNGetN', title: 'Buy N Get N', description: 'Same product free', icon: <GiftIcon />, color: '#f59e0b', bgColor: '#fffbeb', darkBgColor: '#451a03', apiType: 'bogo' },
    { id: 'buyNGetX', title: 'Buy N Get X', description: 'A different product free', icon: <SwapIcon />, color: '#e11d48', bgColor: '#fff1f2', darkBgColor: '#4c0519', apiType: 'bogo' }
  ];

  // 🔴 RED & WHITE THEME-AWARE STYLES
  const getThemeStyles = () => ({
    bgPrimary: isDark ? '#0a0505' : '#ffffff',
    bgSecondary: isDark ? '#140a0a' : '#ffffff',
    bgTertiary: isDark ? '#0f0505' : '#fef2f2',
    textPrimary: isDark ? '#f1f5f9' : '#0f172a',
    textSecondary: isDark ? '#94a3b8' : '#64748b',
    textMuted: isDark ? '#64748b' : '#94a3b8',
    border: isDark ? '#2a1010' : '#fecaca',
    borderLight: isDark ? '#450a0a' : '#fee2e2',
    cardBg: isDark ? '#140a0a' : '#ffffff',
    inputBg: isDark ? '#0f0505' : '#fef2f2',
    hoverBg: isDark ? '#2a1010' : '#fee2e2',
    primary: '#ef4444',
    primaryGradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  });

  const styles = getThemeStyles();
  const productIdOf = (product) => String(product?.product_id ?? product?.id ?? product?.uid ?? '');
  const productCategoryOf = (product) => String(product?.category || product?.main_category || product?.category_name || product?.type || 'Uncategorized').trim() || 'Uncategorized';

  const fetchProducts = async () => {
    if (!designation_id) return;
    setLoadingProducts(true);
    try {
      const response = await postData("offers/menu", { designation_id: designation_id });
      let productsData = [];
      if (response && response.status === true && response.data) {
        response.data.forEach((menuItem) => {
          if (menuItem.items) {
            let itemsJson = menuItem.items;
            if (typeof itemsJson === 'string') {
              try {
                const parsedItems = JSON.parse(itemsJson);
                if (Array.isArray(parsedItems)) productsData = [...productsData, ...parsedItems];
              } catch (parseError) { console.error("Error parsing items JSON:", parseError); }
            } else if (Array.isArray(itemsJson)) {
              productsData = [...productsData, ...itemsJson];
            }
          }
        });
      }
      setProductList(productsData);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchOffers = async () => {
    if (!designation_id) return;
    setLoading(true);
    try {
      const response = await postData("offers/offer", { designation_id: designation_id });
      let offersData = [];
      if (response && response.status === true && response.data) {
        offersData = response.data;
      }
      setOffers(offersData);
    } catch (error) {
      console.error("Error fetching offers:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.state && location.state.designation_id) {
      setDesignationId(location.state.designation_id);
      setRestaurantName(location.state.restaurantName || '');
    } else {
      const storedRestaurant = sessionStorage.getItem('selectedRestaurant');
      if (storedRestaurant) {
        const restaurant = JSON.parse(storedRestaurant);
        setDesignationId(restaurant.designation_id);
        setRestaurantName(restaurant.restaurantName || '');
      }
    }
  }, [location]);

  useEffect(() => {
    if (designation_id) {
      fetchProducts();
      fetchOffers();
    }
  }, [designation_id]);

  const isValid = () => {
    if (!offerName.trim()) { alert('Please enter an offer title'); return false; }
    if (offerScope === 'product' && selectedOfferProductIds.length === 0) { alert('Offer lagane ke liye kam se ek dish select karein'); return false; }
    if (offerScope === 'cart' && (selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX')) { alert('BOGO offers can only be applied to products'); return false; }
    if (offerScope === 'cart' && (!minCartValue || parseFloat(minCartValue) <= 0)) { alert('Please enter a valid minimum cart value'); return false; }
    if (selectedOfferType === 'fixed' && (!discountAmount || parseFloat(discountAmount) <= 0)) { alert('Please enter a valid discount amount'); return false; }
    if (selectedOfferType === 'percentage' && (!discountPercent || parseFloat(discountPercent) <= 0 || parseFloat(discountPercent) > 100)) { alert('Please enter a valid percentage (1-100)'); return false; }
    if ((selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') && (!buyQuantity || parseInt(buyQuantity) <= 0)) { alert('Please enter valid buy quantity'); return false; }
    if (selectedOfferType === 'buyNGetN' && (!getQuantity || parseInt(getQuantity) <= 0)) { alert('Please enter valid get quantity'); return false; }
    if (selectedOfferType === 'buyNGetX' && !selectedFreeProduct) { alert('Please select the free product'); return false; }
    if (validFrom && validTo && new Date(validFrom) > new Date(validTo)) { alert('End date must be after start date'); return false; }
    return true;
  };

  const handleCreateOffer = async () => {
    if (!isValid() || !designation_id) return;
    setIsSubmitting(true);
    const offerTypeMap = { fixed: 'flat', percentage: 'percent', buyNGetN: 'bogo', buyNGetX: 'bogo' };
    
    const targetProducts = productList.filter((product) => selectedOfferProductIds.includes(productIdOf(product)));
    const isBulkProductOffer = offerScope === 'product' && !editingOfferId && targetProducts.length > 1;
    let offerData = {
      id: editingOfferId || undefined,
      designation_id,
      product_id: offerScope === 'product' ? targetProducts[0]?.product_id : null,
      product_name: offerScope === 'product' ? targetProducts[0]?.name : null,
      offer_name: offerName.trim(),
      offer_type: offerTypeMap[selectedOfferType],
      offer_scope: offerScope,
      min_cart_value: offerScope === 'cart' ? minCartValue : 0,
      status: editingOfferId ? undefined : '1',
    };

    if (selectedOfferType === 'fixed') offerData.offer = discountAmount;
    else if (selectedOfferType === 'percentage') offerData.offer = discountPercent;
    else if (selectedOfferType === 'buyNGetN') { offerData.buy_quantity = buyQuantity; offerData.free_quantity = getQuantity; offerData.offer = `${buyQuantity}+${getQuantity}`; }
    else if (selectedOfferType === 'buyNGetX') { offerData.buy_quantity = buyQuantity; offerData.free_quantity = '1'; offerData.item_free = selectedFreeProduct.product_id; offerData.offer = `${buyQuantity}+1`; }
    
    if (validFrom) offerData.offer_start = validFrom;
    if (validTo) offerData.offer_end = validTo;

    try {
      const endpoint = editingOfferId
        ? "offers/update_offer"
        : isBulkProductOffer
          ? "offers/create_bulk_offer"
          : "offers/create_offer";
      if (isBulkProductOffer) {
        offerData.products = targetProducts.map((product) => ({
          product_id: product.product_id,
          name: product.name,
        }));
      }
      const response = await postData(endpoint, offerData);
      if (response && response.status === true) {
        alert(editingOfferId ? 'Offer updated successfully!' : (isBulkProductOffer ? `Offer applied to ${response?.data?.count || targetProducts.length} dishes!` : 'Offer created successfully!'));
        resetForm();
        await fetchOffers();
        setActiveTab('manage');
      } else {
        alert(response?.message || `Failed to ${editingOfferId ? 'update' : 'create'} offer`);
      }
    } catch (error) {
      alert('Failed to create offer: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteOffer = async (offerId) => {
    if (!window.confirm('Are you sure you want to delete this offer?')) return;
    try {
      const response = await postData("offers/delete_offer", { id: offerId });
      if (response && response.status === true) {
        alert('Offer deleted successfully!');
        fetchOffers();
      }
    } catch (error) {
      alert('Failed to delete offer');
    }
  };

  const handleEditOffer = (offer) => {
    const product = productList.find(p => String(p.product_id) === String(offer.product_id));
    if (product) setSelectedProduct(product);
    setSelectedOfferProductIds([]);
    setProductSearch('');
    setEditingOfferId(offer.id);
    setOfferName(offer.offer_name || '');
    setOfferScope(offer.offer_scope || 'product');
    setMinCartValue(offer.min_cart_value ? String(offer.min_cart_value) : '');
    
    if (offer.offer_type === 'flat' || offer.offer_type === 'discount') { setSelectedOfferType('fixed'); setDiscountAmount(offer.offer); }
    else if (offer.offer_type === 'percent' || offer.offer_type === 'percentage') { setSelectedOfferType('percentage'); setDiscountPercent(offer.offer); }
    else if (offer.offer_type === 'bogo' || offer.offer_type === 'buy_get' || offer.offer_type === 'buy_get_x') {
      setSelectedOfferType(offer.item_free ? 'buyNGetX' : 'buyNGetN');
      setBuyQuantity(offer.buy_quantity || '1');
      setGetQuantity(offer.free_quantity || '1');
      const freeProduct = productList.find(p => String(p.product_id) === String(offer.item_free));
      setSelectedFreeProduct(freeProduct || null);
    }
    
    if (offer.offer_start) setValidFrom(offer.offer_start.split(' ')[0]);
    if (offer.offer_end) setValidTo(offer.offer_end.split(' ')[0]);
    setActiveTab('create');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const productForOffer = (offer) => productList.find((product) => productIdOf(product) === String(offer?.product_id || ''));
  const offerCategories = [...new Set(offers.map(productForOffer).filter(Boolean).map(productCategoryOf))].sort();
  const toggleOfferSelection = (offerId) => setSelectedOfferIds((previous) => previous.includes(String(offerId)) ? previous.filter((id) => id !== String(offerId)) : [...previous, String(offerId)]);
  const selectOffersByCategory = (category) => {
    setBulkCategory(category);
    if (!category) return;
    setSelectedOfferIds(offers.filter((offer) => productCategoryOf(productForOffer(offer)) === category).map((offer) => String(offer.id)));
  };
  const handleBulkDeleteOffers = async () => {
    if (!selectedOfferIds.length) return alert('Pehle jis dish ke offers hatane hain unhe select karein.');
    if (!window.confirm(`${selectedOfferIds.length} selected offer(s) remove karne hain? Baaki dishes ke offers safe rahenge.`)) return;
    setBulkDeleting(true);
    try {
      const response = await postData('offers/delete_bulk', { designation_id, offer_ids: selectedOfferIds });
      if (response?.status) {
        alert(response.message || 'Selected offers removed successfully');
        setSelectedOfferIds([]); setBulkCategory(''); await fetchOffers();
      } else alert(response?.message || 'Selected offers remove nahi ho paaye');
    } catch (error) { alert('Selected offers remove nahi ho paaye'); }
    finally { setBulkDeleting(false); }
  };

  useEffect(() => {
    const editOffer = location.state?.editOffer;
    if (!editOffer?.id || productList.length === 0 || initialEditAppliedRef.current === editOffer.id) return;
    initialEditAppliedRef.current = editOffer.id;
    handleEditOffer(editOffer);
  }, [location.state, productList]);

  const resetForm = () => {
    setEditingOfferId(null);
    setOfferName('');
    setOfferScope('product');
    setMinCartValue('');
    setSelectedProduct(null);
    // REMOVED: setApplyToAllProducts(false);
    setSelectedOfferType('fixed');
    setDiscountAmount('');
    setDiscountPercent('');
    setBuyQuantity('');
    setGetQuantity('');
    setSelectedFreeProduct(null);
    setValidFrom('');
    setValidTo('');
  };

  const getOfferTypeText = (type) => {
    const types = { 'flat': 'Flat', 'percent': 'Percentage', 'bogo': 'BOGO', 'combo': 'Combo', 'discount': 'Flat', 'percentage': 'Percentage', 'buy_get': 'Buy N Get N', 'buy_get_x': 'Buy N Get X' };
    return types[type] || type;
  };

  const getOfferDescription = (offer) => {
    if (offer.offer_type === 'flat') return `₹${offer.offer} off`;
    if (offer.offer_type === 'percent') return `${offer.offer}% off`;
    if (offer.offer_type === 'bogo') return `Buy ${offer.buy_quantity || 1}, Get ${offer.free_quantity || 1} free`;
    if (offer.offer_type === 'combo') return `Combo for ₹${offer.offer}`;
    if (offer.offer_type === 'discount') return `₹${offer.offer} off`;
    if (offer.offer_type === 'percentage') return `${offer.offer}% off`;
    if (offer.offer_type === 'buy_get') return `Buy ${offer.buy_quantity}, Get ${offer.free_quantity} free`;
    if (offer.offer_type === 'buy_get_x') return `Buy ${offer.buy_quantity}, Get free product`;
    return offer.offer_name;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const handleBack = () => navigate(-1);
  const getActiveOfferCount = () => offers.filter(offer => Number(offer.status) === 1).length;

  const handleToggleOffer = async (offerId) => {
    try {
      const response = await postData('offers/toggle_status', { id: offerId });
      if (response?.status === true) await fetchOffers();
      else alert(response?.message || 'Failed to update offer status');
    } catch (toggleError) {
      alert('Failed to update offer status');
    }
  };

  if (!hasPermission('restaurants.active_offers')) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: styles.bgPrimary, transition: 'background 0.3s ease' }}>
        <div style={{ textAlign: 'center', background: styles.cardBg, padding: '60px', borderRadius: '24px', maxWidth: '400px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>🔒</div>
          <h2 style={{ color: styles.textPrimary, marginBottom: '8px' }}>Access Denied</h2>
          <p style={{ color: styles.textSecondary }}>You don't have permission to manage offers</p>
          <button 
            onClick={handleBack}
            style={{
              marginTop: '20px', padding: '10px 24px', background: styles.primaryGradient, border: 'none',
              borderRadius: '12px', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: 600,
              transition: 'transform 0.2s ease, opacity 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (!designation_id) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: styles.bgPrimary, transition: 'background 0.3s ease' }}>
        <div style={{ textAlign: 'center', background: styles.cardBg, padding: '40px', borderRadius: '24px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
          <div style={{ width: '48px', height: '48px', border: `3px solid ${styles.border}`, borderTopColor: styles.primary, borderRadius: '50%', margin: '0 auto 16px auto', animation: 'spin 1s linear infinite' }} />
          <p style={{ color: styles.textSecondary, fontSize: '14px' }}>Loading restaurant information...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: styles.bgPrimary, fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", transition: 'all 0.3s ease' }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .offer-card { animation: fadeIn 0.3s ease; }
      `}</style>
      
      <div style={{ position: 'relative', zIndex: 1, padding: '32px 24px' }}>
        {/* Header */}
        <div style={{ maxWidth: '1200px', margin: '0 auto 32px auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
            <button 
              onClick={handleBack} 
              style={{ 
                display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px',
                background: styles.bgTertiary, border: `1px solid ${styles.border}`, borderRadius: '40px',
                color: styles.textPrimary, cursor: 'pointer', fontSize: '14px', fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
              onMouseLeave={(e) => e.currentTarget.style.background = styles.bgTertiary}
            >
              <BackIcon /> Back to Dashboard
            </button>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: styles.bgTertiary, padding: '8px 20px', borderRadius: '40px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
                <SparklesIcon />
                <span style={{ color: styles.textPrimary, fontSize: '14px', fontWeight: '500' }}>{restaurantName}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {/* Stats Cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px' }}>
            {[
              { label: 'Total Products', value: productList.length, icon: <TagIcon /> },
              { label: 'Active Offers', value: getActiveOfferCount(), icon: <TrendingIcon /> },
              { label: 'Total Offers', value: offers.length, icon: <GiftIcon /> }
            ].map((stat, idx) => (
              <div key={idx} style={{ background: styles.cardBg, borderRadius: '20px', padding: '20px', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <p style={{ fontSize: '12px', color: styles.textSecondary, marginBottom: '8px' }}>{stat.label}</p>
                    <p style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary }}>{stat.value}</p>
                  </div>
                  <div style={{ width: '40px', height: '40px', background: styles.bgTertiary, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: styles.primary, transition: 'all 0.3s ease' }}>
                    {stat.icon}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Tabs */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '24px', background: styles.bgTertiary, borderRadius: '60px', padding: '6px', width: 'fit-content', transition: 'all 0.3s ease' }}>
            <button
              onClick={() => setActiveTab('create')}
              style={{
                padding: '12px 28px', borderRadius: '40px', border: 'none', fontSize: '14px', fontWeight: '600',
                cursor: 'pointer', transition: 'all 0.3s ease',
                background: activeTab === 'create' ? styles.bgSecondary : 'transparent',
                color: activeTab === 'create' ? styles.primary : styles.textSecondary
              }}
            >
              ✨ Create Offer
            </button>
            <button
              onClick={() => setActiveTab('manage')}
              style={{
                padding: '12px 28px', borderRadius: '40px', border: 'none', fontSize: '14px', fontWeight: '600',
                cursor: 'pointer', transition: 'all 0.3s ease',
                background: activeTab === 'manage' ? styles.bgSecondary : 'transparent',
                color: activeTab === 'manage' ? styles.primary : styles.textSecondary
              }}
            >
              📋 Manage Offers
            </button>
          </div>

          {/* Create Offer Form */}
          {activeTab === 'create' && (
            <div className="offer-card" style={{ background: styles.cardBg, borderRadius: '32px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
              <div style={{ padding: '32px', borderBottom: `1px solid ${styles.border}`, background: isDark ? '#140a0a' : 'linear-gradient(135deg, #fef2f2 0%, #ffffff 100%)', transition: 'all 0.3s ease' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{ width: '48px', height: '48px', background: styles.primaryGradient, borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)' }}>
                    <SparklesIcon style={{ color: 'white' }} />
                  </div>
                  <div>
                    <h2 style={{ fontSize: '28px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>Create New Offer</h2>
                    <p style={{ fontSize: '14px', color: styles.textSecondary, marginTop: '4px' }}>Design attractive promotions to boost your sales</p>
                  </div>
                </div>
              </div>

              <div style={{ padding: '32px' }}>
                {/* Offer title */}
                <div style={{ marginBottom: '24px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Campaign Title</label>
                  <input
                    type="text"
                    placeholder="e.g., Weekend Special"
                    value={offerName}
                    onChange={(e) => setOfferName(e.target.value)}
                    style={{ width: '100%', boxSizing: 'border-box', padding: '14px 18px', border: `2px solid ${styles.border}`, borderRadius: '16px', background: styles.inputBg, color: styles.textPrimary, fontSize: '14px', outline: 'none' }}
                  />
                </div>

                {/* Offer scope */}
                <div style={{ marginBottom: '24px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '10px' }}>Offer Applies To</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '12px' }}>
                    {[
                      { id: 'product', label: 'Product Offer', hint: 'Apply on one menu item' },
                      { id: 'cart', label: 'Cart Offer', hint: 'Apply above a minimum order' }
                    ].map((scope) => (
                      <button
                        key={scope.id}
                        type="button"
                        onClick={() => {
                          setOfferScope(scope.id);
                          if (scope.id === 'cart') {
                            // REMOVED: setApplyToAllProducts(false);
                            // REMOVED: setApplyToCategory('');
                            if (selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') setSelectedOfferType('percentage');
                          }
                        }}
                        style={{ padding: '15px 18px', borderRadius: '16px', border: `2px solid ${offerScope === scope.id ? styles.primary : styles.border}`, background: offerScope === scope.id ? styles.bgTertiary : styles.cardBg, color: styles.textPrimary, cursor: 'pointer', textAlign: 'left' }}
                      >
                        <strong style={{ display: 'block', fontSize: '14px' }}>{scope.label}</strong>
                        <span style={{ fontSize: '11px', color: styles.textSecondary }}>{scope.hint}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Product Selection */}
                {offerScope === 'product' && (
                <div style={{ marginBottom: '32px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '700', color: styles.textPrimary, marginBottom: '6px' }}>Choose dishes for this offer</label>
                  <p style={{ color: styles.textSecondary, fontSize: '12px', margin: '0 0 12px' }}>Search “pizza” and select Pizza dishes. Or select all, search “roll”, then untick Rolls.</p>
                  <input value={productSearch} onChange={(event) => setProductSearch(event.target.value)} placeholder="Search dish: pizza, roll, burger..." style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: '10px', border: `1px solid ${styles.border}`, background: styles.inputBg, color: styles.textPrimary, marginBottom: '10px' }} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '9px', flexWrap: 'wrap', marginBottom: '10px' }}>
                    <button type="button" onClick={() => setSelectedOfferProductIds(productList.map(productIdOf))} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textPrimary, cursor: 'pointer', fontWeight: 700, fontSize: '12px' }}>Select all dishes</button>
                    <button type="button" onClick={() => setSelectedOfferProductIds([])} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textSecondary, cursor: 'pointer', fontWeight: 700, fontSize: '12px' }}>Clear selection</button>
                    <span style={{ color: styles.primary, fontWeight: 800, fontSize: '12px' }}>{selectedOfferProductIds.length} dish(es) selected</span>
                  </div>
                  <div style={{ maxHeight: '280px', overflowY: 'auto', border: `1px solid ${styles.border}`, borderRadius: '12px', background: styles.cardBg }}>
                    {loadingProducts ? <div style={{ padding: '18px', color: styles.textMuted }}>Loading dishes...</div> : productList.filter((product) => `${product.name || ''} ${productCategoryOf(product)}`.toLowerCase().includes(productSearch.toLowerCase())).map((product) => {
                      const id = productIdOf(product); const checked = selectedOfferProductIds.includes(id);
                      return <label key={id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 13px', borderBottom: `1px solid ${styles.borderLight}`, cursor: 'pointer', background: checked ? styles.bgTertiary : 'transparent' }}>
                        <input type="checkbox" checked={checked} onChange={() => setSelectedOfferProductIds((previous) => checked ? previous.filter((item) => item !== id) : [...previous, id])} style={{ accentColor: styles.primary, width: '16px', height: '16px' }} />
                        <span style={{ flex: 1, color: styles.textPrimary, fontSize: '13px', fontWeight: 600 }}>{product.name}</span><span style={{ color: styles.textMuted, fontSize: '11px' }}>{productCategoryOf(product)}</span>
                      </label>;
                    })}
                  </div>
                </div>
                )}

                {offerScope === 'cart' && (
                  <div style={{ marginBottom: '32px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Minimum Cart Value (₹)</label>
                    <input
                      type="number"
                      min="1"
                      placeholder="e.g., 499"
                      value={minCartValue}
                      onChange={(e) => setMinCartValue(e.target.value)}
                      style={{ width: '100%', boxSizing: 'border-box', padding: '14px 18px', border: `2px solid ${styles.border}`, borderRadius: '16px', background: styles.inputBg, color: styles.textPrimary, fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                )}

                {/* Offer Type Selection */}
                <div style={{ marginBottom: '32px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '12px' }}>Offer Type</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                    {offerTypes.map((type) => (
                      <button
                        key={type.id}
                        disabled={offerScope === 'cart' && (type.id === 'buyNGetN' || type.id === 'buyNGetX')}
                        onClick={() => setSelectedOfferType(type.id)}
                        style={{
                          padding: '20px', borderRadius: '20px',
                          border: `2px solid ${selectedOfferType === type.id ? type.color : styles.border}`,
                          background: selectedOfferType === type.id ? (isDark ? type.darkBgColor : type.bgColor) : styles.cardBg,
                          cursor: 'pointer', textAlign: 'center', transition: 'all 0.3s ease',
                          transform: selectedOfferType === type.id ? 'scale(1.02)' : 'scale(1)',
                          opacity: offerScope === 'cart' && (type.id === 'buyNGetN' || type.id === 'buyNGetX') ? 0.45 : 1
                        }}
                      >
                        <div style={{
                          width: '56px', height: '56px', borderRadius: '28px',
                          background: selectedOfferType === type.id ? `${type.color}20` : styles.bgTertiary,
                          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px auto',
                          color: selectedOfferType === type.id ? type.color : styles.textSecondary, transition: 'all 0.3s ease'
                        }}>
                          {type.icon}
                        </div>
                        <span style={{ fontSize: '15px', fontWeight: '600', color: selectedOfferType === type.id ? type.color : styles.textPrimary, marginBottom: '4px', display: 'block' }}>{type.title}</span>
                        <span style={{ fontSize: '12px', color: styles.textSecondary }}>{type.description}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Dynamic Fields */}
                {(selectedOfferType === 'fixed' || selectedOfferType === 'percentage') && (
                  <div style={{ marginBottom: '32px' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>
                      {selectedOfferType === 'fixed' ? 'Discount Amount (₹)' : 'Discount Percentage (%)'}
                    </label>
                    <div style={{ 
                      display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', 
                      backgroundColor: styles.inputBg, transition: 'all 0.2s ease'
                    }}>
                      {selectedOfferType === 'fixed' ? 
                        <span style={{ fontSize: '20px', fontWeight: '600', color: styles.primary, marginRight: '12px' }}>₹</span> : 
                        <div style={{ marginRight: '12px', color: styles.primary }}><PercentIcon /></div>
                      }
                      <input 
                        type="number" 
                        style={{ 
                          flex: 1, padding: '14px 0', fontSize: '16px', fontWeight: '500', border: 'none', outline: 'none', 
                          backgroundColor: 'transparent', color: styles.textPrimary
                        }} 
                        placeholder={selectedOfferType === 'fixed' ? 'e.g., 500' : 'e.g., 20'} 
                        value={selectedOfferType === 'fixed' ? discountAmount : discountPercent} 
                        onChange={(e) => selectedOfferType === 'fixed' ? setDiscountAmount(e.target.value) : setDiscountPercent(e.target.value)} 
                      />
                      {selectedOfferType === 'percentage' && <span style={{ fontSize: '16px', fontWeight: '500', color: styles.textSecondary, marginLeft: '8px' }}>%</span>}
                    </div>
                  </div>
                )}

                {(selectedOfferType === 'buyNGetN' || selectedOfferType === 'buyNGetX') && (
                  <>
                    <div style={{ marginBottom: '24px' }}>
                      <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Buy Quantity</label>
                      <div style={{ display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
                        <GiftIcon style={{ color: styles.primary }} />
                        <input 
                          type="number" 
                          style={{ flex: 1, padding: '14px 0', fontSize: '16px', border: 'none', outline: 'none', backgroundColor: 'transparent', marginLeft: '12px', color: styles.textPrimary }} 
                          placeholder="e.g., 2" 
                          value={buyQuantity} 
                          onChange={(e) => setBuyQuantity(e.target.value)} 
                        />
                      </div>
                    </div>
                    {selectedOfferType === 'buyNGetN' && (
                      <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Get Quantity (Free)</label>
                        <div style={{ display: 'flex', alignItems: 'center', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '0 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
                          <GiftIcon style={{ color: '#10B981' }} />
                          <input 
                            type="number" 
                            style={{ flex: 1, padding: '14px 0', fontSize: '16px', border: 'none', outline: 'none', backgroundColor: 'transparent', marginLeft: '12px', color: styles.textPrimary }} 
                            placeholder="e.g., 1" 
                            value={getQuantity} 
                            onChange={(e) => setGetQuantity(e.target.value)} 
                          />
                        </div>
                      </div>
                    )}
                    {selectedOfferType === 'buyNGetX' && (
                      <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Free Product</label>
                        <div style={{ position: 'relative' }}>
                          <button 
                            onClick={() => setShowFreeProductDropdown(!showFreeProductDropdown)} 
                            style={{ 
                              width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', 
                              border: `2px solid ${styles.border}`, borderRadius: '16px', backgroundColor: styles.inputBg, cursor: 'pointer', 
                              fontSize: '14px', color: styles.textPrimary, transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.borderColor = styles.primary}
                            onMouseLeave={(e) => e.currentTarget.style.borderColor = styles.border}
                          >
                            <span style={selectedFreeProduct ? { color: styles.textPrimary, fontWeight: '500' } : { color: styles.textMuted }}>
                              {selectedFreeProduct ? selectedFreeProduct.name : 'Select free product'}
                            </span>
                            <ChevronDownIcon />
                          </button>
                          {showFreeProductDropdown && (
                            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: '8px', border: `1px solid ${styles.border}`, borderRadius: '16px', backgroundColor: styles.cardBg, zIndex: 10, maxHeight: '250px', overflow: 'auto', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)', transition: 'all 0.3s ease' }}>
                              {productList.filter(p => p.product_id !== selectedProduct?.product_id).map((product) => (
                                <div 
                                  key={product.product_id} 
                                  onClick={() => { setSelectedFreeProduct(product); setShowFreeProductDropdown(false); }} 
                                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', cursor: 'pointer', borderBottom: `1px solid ${styles.borderLight}`, transition: 'background 0.2s ease' }}
                                  onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
                                  onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                >
                                  <span style={{ fontSize: '14px', color: styles.textPrimary }}>{product.name}</span>
                                  {selectedFreeProduct?.product_id === product.product_id && <CheckIcon style={{ color: '#10B981' }} />}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* Validity */}
                <div style={{ marginBottom: '32px' }}>
                  <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: styles.textPrimary, marginBottom: '8px' }}>Validity Period (Optional)</label>
                  <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '10px 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
                      <CalendarIcon style={{ color: styles.primary }} />
                      <input 
                        type="date" 
                        style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '14px', color: styles.textPrimary }} 
                        value={validFrom} 
                        onChange={(e) => setValidFrom(e.target.value)} 
                      />
                      <span style={{ fontSize: '12px', color: styles.textMuted }}>Start</span>
                    </div>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', border: `2px solid ${styles.border}`, borderRadius: '16px', padding: '10px 20px', backgroundColor: styles.inputBg, transition: 'all 0.2s ease' }}>
                      <ClockIcon style={{ color: styles.primary }} />
                      <input 
                        type="date" 
                        style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: '14px', color: styles.textPrimary }} 
                        value={validTo} 
                        onChange={(e) => setValidTo(e.target.value)} 
                      />
                      <span style={{ fontSize: '12px', color: styles.textMuted }}>End</span>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <button 
                  onClick={handleCreateOffer} 
                  disabled={isSubmitting} 
                  style={{ 
                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', padding: '16px',
                    background: isSubmitting ? (isDark ? '#4B5563' : '#9CA3AF') : styles.primaryGradient,
                    border: 'none', borderRadius: '20px', color: '#FFFFFF', fontSize: '16px', fontWeight: '600', 
                    cursor: isSubmitting ? 'not-allowed' : 'pointer', boxShadow: isSubmitting ? 'none' : '0 4px 12px rgba(239, 68, 68, 0.3)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease, background 0.3s ease'
                  }}
                  onMouseEnter={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(-2px)')}
                  onMouseLeave={(e) => !isSubmitting && (e.currentTarget.style.transform = 'translateY(0)')}
                >
                  <PlusIcon />
                  <span>{isSubmitting ? (editingOfferId ? 'Updating Offer...' : 'Creating Offer...') : (editingOfferId ? 'Update Offer' : 'Create Offer')}</span>
                </button>
                {editingOfferId && (
                  <button
                    type="button"
                    onClick={resetForm}
                    style={{ width: '100%', marginTop: '10px', padding: '12px', borderRadius: '16px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textSecondary, cursor: 'pointer', fontWeight: 600 }}
                  >
                    Cancel Editing
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Manage Offers Table */}
          {activeTab === 'manage' && (
            <div ref={offersSectionRef} style={{ background: styles.cardBg, borderRadius: '32px', overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)', border: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
              <div style={{ padding: '24px 32px', borderBottom: `1px solid ${styles.border}`, background: isDark ? '#140a0a' : 'linear-gradient(135deg, #fef2f2 0%, #ffffff 100%)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', transition: 'all 0.3s ease' }}>
                <div>
                  <h3 style={{ fontSize: '20px', fontWeight: '700', color: styles.textPrimary, margin: 0 }}>All Offers</h3>
                  <p style={{ fontSize: '14px', color: styles.textSecondary, marginTop: '4px' }}>Manage and monitor your existing promotions</p>
                </div>
                <button 
                  onClick={fetchOffers} 
                  style={{ 
                    display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 20px', 
                    background: styles.primaryGradient, border: 'none', borderRadius: '12px', color: 'white', 
                    fontSize: '13px', fontWeight: '500', cursor: 'pointer', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
                    transition: 'transform 0.2s ease, opacity 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-1px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <EyeIcon /> Refresh ({offers.length})
                </button>
              </div>

              <div style={{ padding: '14px 32px', borderBottom: `1px solid ${styles.border}`, display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', background: styles.bgTertiary }}>
                <select value={bulkCategory} onChange={(event) => selectOffersByCategory(event.target.value)} style={{ minWidth: '190px', padding: '9px 11px', borderRadius: '9px', border: `1px solid ${styles.border}`, color: styles.textPrimary, background: styles.cardBg }}>
                  <option value="">Select a category to select its offers</option>
                  {offerCategories.map((category) => <option key={category} value={category}>{category}</option>)}
                </select>
                <span style={{ color: styles.textSecondary, fontSize: '12px', fontWeight: 600 }}>{selectedOfferIds.length} offer(s) selected</span>
                <button onClick={() => setSelectedOfferIds(offers.map((offer) => String(offer.id)))} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textPrimary, cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Select all</button>
                <button onClick={() => setSelectedOfferIds([])} style={{ padding: '8px 11px', borderRadius: '8px', border: `1px solid ${styles.border}`, background: styles.cardBg, color: styles.textSecondary, cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Clear</button>
                <button disabled={!selectedOfferIds.length || bulkDeleting} onClick={handleBulkDeleteOffers} style={{ marginLeft: 'auto', padding: '9px 13px', borderRadius: '8px', border: 'none', background: !selectedOfferIds.length || bulkDeleting ? '#94a3b8' : '#dc2626', color: '#fff', cursor: !selectedOfferIds.length || bulkDeleting ? 'not-allowed' : 'pointer', fontWeight: 700, fontSize: '12px' }}>{bulkDeleting ? 'Removing…' : 'Remove selected offers'}</button>
              </div>

              {loading ? (
                <div style={{ textAlign: 'center', padding: '60px', color: styles.textSecondary }}>
                  <div style={{ width: '48px', height: '48px', border: `3px solid ${styles.border}`, borderTopColor: styles.primary, borderRadius: '50%', margin: '0 auto 16px auto', animation: 'spin 1s linear infinite' }} />
                  <p>Loading offers...</p>
                </div>
              ) : error ? (
                <div style={{ textAlign: 'center', padding: '60px', color: '#EF4444' }}>
                  <p>Error loading offers: {error}</p>
                  <button onClick={fetchOffers} style={{ marginTop: '16px', padding: '10px 24px', background: styles.primaryGradient, border: 'none', borderRadius: '12px', color: '#fff', cursor: 'pointer', transition: 'opacity 0.2s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                  >Try Again</button>
                </div>
              ) : offers.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '80px 40px', color: styles.textMuted }}>
                  <div style={{ width: '80px', height: '80px', background: styles.bgTertiary, borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto', transition: 'all 0.3s ease' }}>
                    <TagIcon style={{ width: '40px', height: '40px', opacity: 0.5, color: styles.primary }} />
                  </div>
                  <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px', color: styles.textPrimary }}>No offers yet</p>
                  <p style={{ fontSize: '13px' }}>Create your first offer to start attracting more customers</p>
                  <button 
                    onClick={() => setActiveTab('create')} 
                    style={{ marginTop: '20px', padding: '10px 24px', background: styles.primaryGradient, border: 'none', borderRadius: '12px', color: 'white', cursor: 'pointer', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)', transition: 'transform 0.2s ease' }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                  >
                    Create Offer
                  </button>
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: styles.bgTertiary, borderBottom: `1px solid ${styles.border}`, transition: 'all 0.3s ease' }}>
                        <th style={{ padding: '16px 12px', textAlign: 'center' }}><input type="checkbox" checked={offers.length > 0 && selectedOfferIds.length === offers.length} onChange={(event) => setSelectedOfferIds(event.target.checked ? offers.map((offer) => String(offer.id)) : [])} /></th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>#</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Offer Name</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Dish</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Type</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Details</th>
                        <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Validity</th>
                        <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Status</th>
                        <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: styles.textSecondary }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {offers.map((offer, index) => (
                        <tr key={offer.id} style={{ borderBottom: `1px solid ${styles.borderLight}`, transition: 'background 0.2s ease' }}
                          onMouseEnter={(e) => e.currentTarget.style.background = styles.hoverBg}
                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                          <td style={{ padding: '16px 12px', textAlign: 'center' }}><input type="checkbox" checked={selectedOfferIds.includes(String(offer.id))} onChange={() => toggleOfferSelection(offer.id)} /></td>
                          <td style={{ padding: '16px 20px', fontSize: '14px', fontWeight: '500', color: styles.textPrimary }}>{index + 1}</td>
                          <td style={{ padding: '16px 20px', fontSize: '14px', fontWeight: '600', color: styles.textPrimary }}>{offer.offer_name}</td>
                          <td style={{ padding: '16px 20px', fontSize: '13px', color: styles.textSecondary }}>{offer.product_name || productForOffer(offer)?.name || (offer.offer_scope === 'cart' ? 'Cart offer' : '—')}</td>
                          <td style={{ padding: '16px 20px' }}>
                            <span style={{ 
                              display: 'inline-block', padding: '4px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '600',
                              background: offer.offer_type === 'discount' ? (isDark ? '#450a0a' : '#fef2f2') : 
                                        offer.offer_type === 'percentage' ? (isDark ? '#450a0a' : '#fef2f2') :
                                        offer.offer_type === 'buy_get' ? (isDark ? '#451a03' : '#fffbeb') : (isDark ? '#4c0519' : '#fff1f2'),
                              color: offer.offer_type === 'discount' ? '#ef4444' : 
                                     offer.offer_type === 'percentage' ? '#dc2626' :
                                     offer.offer_type === 'buy_get' ? '#f59e0b' : '#e11d48',
                              transition: 'all 0.3s ease'
                            }}>
                              {getOfferTypeText(offer.offer_type)}
                            </span>
                          </td>
                          <td style={{ padding: '16px 20px', fontSize: '13px', color: styles.textSecondary }}>{getOfferDescription(offer)}</td>
                          <td style={{ padding: '16px 20px', fontSize: '12px', color: styles.textSecondary }}>
                            {formatDate(offer.offer_start)} → {formatDate(offer.offer_end)}
                          </td>
                          <td style={{ padding: '16px 20px', textAlign: 'center' }}>
                            <button onClick={() => handleToggleOffer(offer.id)} title="Click to activate/deactivate" style={{ 
                              display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '4px 12px', borderRadius: '20px', 
                              fontSize: '11px', fontWeight: '600', 
                              background: Number(offer.status) === 1 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(148, 163, 184, 0.1)', 
                              color: Number(offer.status) === 1 ? '#22c55e' : '#94a3b8',
                              transition: 'all 0.3s ease', border: 'none', cursor: 'pointer'
                            }}>
                              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: Number(offer.status) === 1 ? '#22c55e' : '#94a3b8' }}></span>
                              {Number(offer.status) === 1 ? 'Active' : 'Inactive'}
                            </button>
                          </td>
                          <td style={{ padding: '16px 20px', textAlign: 'center' }}>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                              <button 
                                onClick={() => handleEditOffer(offer)} 
                                style={{ 
                                  padding: '8px', background: 'transparent', border: 'none', cursor: 'pointer', color: '#f59e0b', borderRadius: '8px',
                                  transition: 'background 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = isDark ? '#451a03' : '#fffbeb'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                title="Edit Offer"
                              >
                                <EditIcon />
                              </button>
                              <button 
                                onClick={() => handleDeleteOffer(offer.id)} 
                                style={{ 
                                  padding: '8px', background: 'transparent', border: 'none', cursor: 'pointer', color: '#ef4444', borderRadius: '8px',
                                  transition: 'background 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = isDark ? '#450a0a' : '#fef2f2'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                title="Delete Offer"
                              >
                                <TrashIcon />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddOffer;